import colors from './colors';
import sizes from './sizes';
import typography from './typography';

export const foundations = {
  colors,
  ...typography,
  sizes,
};
